module.exports = __webpack_public_path__ + "img/Verify.13667910.svg";